import { render } from "./Painter.vue?vue&type=template&id=0bfbbff0&ts=true"
import script from "./Painter.vue?vue&type=script&lang=ts"
export * from "./Painter.vue?vue&type=script&lang=ts"

import "./Painter.vue?vue&type=style&index=0&id=0bfbbff0&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__